"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNQErrorSchemeJsSdkValues = exports.isNqError = exports.createNqError = void 0;
const R = __importStar(require("ramda"));
const utils_1 = require("./util/utils");
/**
 * Ap/Dn/Up/Pn/Rp/St/En - API / Download / Upload / Ping / Remote port detection / Tcp Stats / Engine
 * Cn/Re - connectivity / unexpected response
 * Cl - client
 * Hr - history error (Dc - decode, En - encode)
 * Rl - rate limit
 * Ps - parallel speedtests
 * Sm - System under maintenance
 * Bm - Benchmark error
 * Br - Browser error (incompatible version)
 **/
// AA-BB-n
// AA-n
// n number range 50..99 is reserved for use in Fusion
const ClientErrorSchemeValues = [
    "Cl-0",
    "Cl-1",
    "Cl-2",
    "Cl-3",
    "Cl-4",
    "Cl-5",
    "Cl-6",
    "Cl-7",
    "Cl-8",
    "Cl-9",
    "Cl-10",
    "Cl-11",
    "Cl-12",
    "Cl-13",
    "Cl-14",
    "Cl-15",
    "Cl-16",
    "Cl-17",
    "Cl-18",
    "Cl-19", // benchmark observable error
];
const HistoryErrorSchemeValues = [
    "Hr-Dc-0",
    "Hr-Dc-1",
    "Hr-Dc-2",
    "Hr-Dc-3",
    "Hr-Dc-4",
    "Hr-Dc-5",
    "Hr-Dc-6",
    "Hr-Dc-7",
    "Hr-En-1", // wrong measurement phase
];
const BenchmarkErrorSchemeValues = [
    "Bm-1",
    "Bm-2",
    "Bm-3", // benchmart timeout error
];
const SystemUnderMaintenanceErrorSchemeValues = [
    "Sm-1", // system under maintenance
];
const BrowserErrorSchemeValues = [
    "Br-1", // incompatible browser version
];
const RateLimitErrorSchemeValues = [
    "Rl-1", // rate limit
];
const ParallelSpeedtestsErrorSchemeValues = [
    "Ps-1", // parallel speedtests
];
const ApiErrorSchemeValues = [
    "Ap-Re-1",
    "Ap-Re-2",
    "Ap-Re-3",
    "Ap-Re-4",
    "Ap-Re-5",
    "Ap-Re-6",
    "Ap-Cn-1",
    "Ap-Cn-2", // Connectivity error while API request (TypeError)
];
const RemotePortDetectionErrorSchemeValues = [
    "Rp-Cn-1",
    "Rp-Cn-2", // remote port detection error
];
const DownloadErrorSchemeValues = [
    "Dn-Cn-1",
    "Dn-Cn-2", // download timeout
];
const UploadErrorSchemeValues = [
    "Up-Cn-1",
    "Up-Cn-2",
    "Up-Cn-3", // no intermediate results
];
const PingErrorSchemeValues = [
    "Pn-Cn-1",
    "Pn-Cn-2", // ping intermediate value list is empty
];
const NqErrorName = "NQError";
const createNqError = (scheme, message, cause) => {
    return {
        name: NqErrorName,
        scheme,
        message,
        additionalInfo: R.isNil(cause) ? null : (0, utils_1.safeStringify)({ cause }),
    };
};
exports.createNqError = createNqError;
const isNqError = (obj) => {
    if (R.prop("name", obj) == NqErrorName) {
        return R.propIs(String, "scheme", obj) && R.propIs(String, "message", obj);
    }
    else {
        return false;
    }
};
exports.isNqError = isNqError;
const getNQErrorSchemeJsSdkValues = () => [
    ClientErrorSchemeValues,
    HistoryErrorSchemeValues,
    BenchmarkErrorSchemeValues,
    SystemUnderMaintenanceErrorSchemeValues,
    BrowserErrorSchemeValues,
    RateLimitErrorSchemeValues,
    ParallelSpeedtestsErrorSchemeValues,
    ApiErrorSchemeValues,
    RemotePortDetectionErrorSchemeValues,
    DownloadErrorSchemeValues,
    UploadErrorSchemeValues,
    PingErrorSchemeValues,
].flat();
exports.getNQErrorSchemeJsSdkValues = getNQErrorSchemeJsSdkValues;
//# sourceMappingURL=NQError.js.map